export const iconFontAwesomeAutomotiveTruckMedical = (
	<i className="fa-solid fa-truck-medical"></i>
);
